module.exports = __webpack_public_path__ + "static/media/street4.a9b0aa09.jpg";